import { css } from '@emotion/core'

export const customTooltipWrapper = css`
    width: min-content;
    display: inline-block;
`
export const customTooltip = css`
    transform: translateX(-45%);
    width: 10rem;
`

export const customDialog = css`
  width: 40rem;
  max-width: 100%;
`
